import React, { useEffect } from "react";
import "../styles/ImpactOfEinv.css";
import Navigation from "../components/Navbar";
import Footer from "../components/Footer";
import impactData from "../assests/JSON/ImpactOfEinv.json";
import Seo from "../components/Seo";

const ImpactOfEinv = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on page load
  }, []);
  return (
    <section>
        <Seo path="/impact-of-einvoicing" />
      <Navigation />
      <div className="impact-container">
        <h2>{impactData.heading}</h2>
        <ul>
          {impactData.impacts.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      </div>
      <div className="impact-bottomImageWrapper">
        <img
          src={require(`../assests/images/${impactData.imagePath}`)}
          alt="Process"
          className="impact-bottom-image"
        />
      </div>
      <Footer />
    </section>
  );
};

export default ImpactOfEinv;
